import { render, staticRenderFns } from "./verdok_pmptsp.vue?vue&type=template&id=3f0030a0&scoped=true"
import script from "./verdok_pmptsp.vue?vue&type=script&lang=js"
export * from "./verdok_pmptsp.vue?vue&type=script&lang=js"
import style0 from "./verdok_pmptsp.vue?vue&type=style&index=0&id=3f0030a0&prod&lang=scss"
import style1 from "./verdok_pmptsp.vue?vue&type=style&index=1&id=3f0030a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0030a0",
  null
  
)

export default component.exports